import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=3b3e0ada"
import script from "./StarIcon.vue?vue&type=script&lang=ts"
export * from "./StarIcon.vue?vue&type=script&lang=ts"
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=3b3e0ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports